module.exports = __webpack_public_path__ + "img/banner1.a503d5e3.png";